module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dTHtQ"))).then(() => parcelRequire('d0iPb'));